import Vue from 'vue'
import {country} from '@/store/data.js'
import numeral from 'numeral'
import axios from 'axios'
import moment from 'moment'

Vue.filter('date', function (value, format) {
  if (!value) return ''
  let form = format ? format : 'YYYY-MM-DD'
  let date = moment(value).format(form)
  return date
});
Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
});
Vue.filter('switch_payment_method', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  switch(value) {
    case 'kr_banktransfer': return "계좌이체"
    case "intl_banktransfer": return "해외계좌이체"
    case 'paypal':  return "PayPal"
    case "payoneer":  return "Payoneer"
    default: return value;
  }
  
});

Vue.filter('switch_country', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()
  
  if(value) {
    const countryData = country
    let rrr =  countryData.filter(result =>{return result.code.toLowerCase() == value.toLowerCase()})
    
    if(rrr.length > 0)return rrr[0].name
    
    else return value
  }
  
});
Vue.filter('switch_entity', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  switch(value) {
    case 'individual': return "개인";
    case "corporation": return "사업자";
    default: return value;
  }
});
Vue.filter('switch_currency', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  switch(value) {
    case 'krw': return "₩(원)";
    case "usd": return "$(달러)";
    case "eur": return "€(유로)";
    default: return value;
}
});


Vue.filter('flatten', function (value, replacer = '_') {
  if (!value) return {}
  var value = {};

  function recurse(cur, prop) {
      if (Object(cur) !== cur) {
          result[prop] = cur;
      } else if (Array.isArray(cur)) {
          for (var i = 0, l = cur.length; i < l; i++)
          recurse(cur[i], prop + "[" + i + "]");
          if (l == 0) result[prop] = [];
      } else {
          var isEmpty = true;
          for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "." + p : p);
          }
          if (isEmpty && prop) result[prop] = {};
      }
  }
  recurse(data, "");
  return result;
});

Vue.filter('unflatten', function (data ) {
  if (!value) return {}

 
  if (Object(data) !== data || Array.isArray(data)) return data;
  var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
      resultholder = {};
  for (var p in data) {
      var cur = resultholder,
          prop = "",
          m;
      while (m = regex.exec(p)) {
          cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
          prop = m[2] || m[1];
      }
      cur[prop] = data[p];
  }
  return resultholder[""] || resultholder;
});
Vue.filter('currencyNumber', function (data,cur) {
  if (!data ||  data == '') return 0
  let num  = Math.floor(data * 10000) / 10000 
  let text = ''
  // switch(cur) {
  //   case 'krw': ;
  //   case "usd": text = " $";
  //   case "eur": text = " €";
  //   default: text = '';
  // }
  if(cur === 'krw'){
    text =  " ₩"
    num = Math.floor(num)
    return numeral(num).format("0,0") + text ;
  }else if(cur == 'usd'){
    text = " $"
    num = parseFloat(num).toFixed(4)
    return numeral(num).format("0,0[.][0000]") + text;
  }else if(cur == 'eur'){
    text = " €"
    num =+ parseFloat(num).toFixed(4)
    return numeral(num).format("0,0[.][0000]") + text;
  }else{
    num =+ parseFloat(num).toFixed(4)
    return numeral(num).format("0,0[.][0000]") ;
  }
  
});

Vue.filter('number', function (data) {
  if (!data ||  data == '') return 0
  let num  = Math.floor(data * 10000) / 10000 
  num = +parseFloat(num).toFixed(4)
  return numeral(num).format("0,0[.][0000]") ;
  ;
});
Vue.filter('number2', function (data ) {
  if (!data) return 0
  let num  = Math.floor(data * 100) / 100 
  num = +parseFloat(num).toFixed(2)
  return numeral(num).format("0,0[.][00]") ;
  ;
});
Vue.filter('number3', function (data ) {
  if (!data) return 0
  let num  = data 
  return numeral(num).format("0,0[.][00000000000000]") ;;
  ;
});

Vue.filter('uppercase', function (data ) {
  
  if (!data) return ''
  return String(data).toUpperCase()
  ;
});

// Vue.filter('number', {
//   read: function(val) {
//     if (!val) return ''
//     return numeral(val).format("0,0[.]0000") ;
//   },
//   // view -> model
//   // formats the value when updating the data.
//   write: function(val, oldVal) {
//     if (!val) return ''
//     var number = +val.replace(/[^\d.]/g, '')
//     return number
//   }
// });
